import React from 'react';
import { StarfieldBackground } from '../components/StarfieldBackground';
import { HeroSection } from '../sections/HeroSection';
import { PainSection } from '../sections/PainSection';
import { ScienceSection } from '../sections/ScienceSection';
import { MysticalSection } from '../sections/MysticalSection';
import { ProductRevealSection } from '../sections/ProductRevealSection';
import { AuthoritySection } from '../sections/AuthoritySection';
import { TestimonialsSection } from '../sections/TestimonialsSection';
import { ValueStackSection } from '../sections/ValueStackSection';
import { GuaranteeSection } from '../sections/GuaranteeSection';
import { UrgencySection } from '../sections/UrgencySection';
import { ClosingSection } from '../sections/ClosingSection';
import { Footer } from '../sections/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cosmic-black text-lunar-white font-lato overflow-x-hidden selection:bg-violet/30 selection:text-white" data-id="element-28">
      <StarfieldBackground data-id="element-29" />

      <HeroSection data-id="element-30" />
      <PainSection data-id="element-31" />
      <ScienceSection data-id="element-32" />
      <MysticalSection data-id="element-33" />
      <ProductRevealSection data-id="element-34" />
      <AuthoritySection data-id="element-35" />
      <TestimonialsSection data-id="element-36" />
      <ValueStackSection data-id="element-37" />
      <GuaranteeSection data-id="element-38" />
      <UrgencySection data-id="element-39" />
      <ClosingSection data-id="element-40" />
      <Footer data-id="element-41" />
    </main>;
}